import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { loadStripe } from "@stripe/stripe-js";
import { ApiService } from '@shared/services/api.service';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.css']
})
export class CheckoutComponent implements OnInit {

  isLoading: boolean = false;

  constructor(private router: Router, private route: ActivatedRoute, private api: ApiService) { }

  ngOnInit() {
  }

  async checkout() {
    this.isLoading = true;
    const stripePromise = loadStripe("pk_live_51J0XFbChcOiLEout2nQkZKvuWhT1u4sFsK9D9UQUG9oHGAPtXEg5vsYvGxfDGv1wRkAeeAhPFq828ngNlNOsIek500HgwihGNr");
    const stripe = await stripePromise;
    this.api.createCheckoutSession().subscribe((session) => {
      stripe.redirectToCheckout({
        sessionId: session["id"]
      });
    });
  }
}